import { render } from "./LayoutCompanyInformation.vue?vue&type=template&id=7321ddae"
import script from "./LayoutCompanyInformation.vue?vue&type=script&lang=js"
export * from "./LayoutCompanyInformation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__